import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Card,
  Col,
  Modal,
  Form,
  Button,
  Offcanvas,
  Badge,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Breadcrumb from "Common/BreadCrumb";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Flatpickr from "react-flatpickr";
import { useFetchClassesQuery } from "features/classes/classeSlice";
import {
  useAddObservationMutation,
  useDeleteObservationMutation,
  useFetchObservationsQuery,
  useBulkDeleteObservationsMutation,
} from "features/observations/observationSlice";
import { useFetchEnseignantsQuery } from "features/enseignants/enseignantSlice";
import { convertToBase64 } from "helpers/base64_convert";
import { French } from "flatpickr/dist/l10n/fr";
import { formatDate } from "helpers/data_time_format";

import Select from "react-select";
import {
  useFetchSmsSettingsQuery,
  useUpdateSmsSettingByIdMutation,
} from "features/smsSettings/smsSettings";
import UpdateObservation from "./UpdateObservation";

const Observations = () => {
  const { data = [] } = useFetchObservationsQuery();
  const { data: AllClasses = [] } = useFetchClassesQuery();
  const { data: AllEnseignants = [] } = useFetchEnseignantsQuery();
  const { data: AllSmsSettings, isLoading = [] } = useFetchSmsSettingsQuery();

  const [deleteObservation] = useDeleteObservationMutation();
  const [bulkDeleteObservations] = useBulkDeleteObservationsMutation();

  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const handleRowSelected = (state: any) => {
    setSelectedRows(state.selectedRows);
  };

  const handleBulkDelete = async () => {
    if (selectedRows.length === 0) return;
    const result = await swalWithBootstrapButtons.fire({
      title: "Suppression groupée",
      text: `Supprimer ${selectedRows.length} observation(s) sélectionnée(s) ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimer !",
      cancelButtonText: "Annuler",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      const ids = selectedRows.map((r: any) => r._id);
      await bulkDeleteObservations(ids).unwrap();
      setToggleCleared(!toggleCleared);
      setSelectedRows([]);
      notifySuccess(`${ids.length} observation(s) supprimée(s)`);
    }
  };

  const [showObservation, setShowObservation] = useState<boolean>(false);

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const handleDateChange = (selectedDates: Date[]) => {
    setSelectedDate(selectedDates[0]);
  };

  const optionColumnsTable = [...AllClasses].sort((a: any, b: any) => (a.nom_classe || "").localeCompare(b.nom_classe || "", "fr")).map((classe: any) => ({
    value: classe?._id!,
    label: classe?.nom_classe!,
  }));

  const [selectedColumnValues, setSelectedColumnValues] = useState<any[]>([]);

  const handleSelectValueColumnChange = (selectedOption: any) => {
    const values = selectedOption.map((option: any) => option.value);
    setSelectedColumnValues(values);
  };

  const notifySuccess = (msg: string) => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: msg,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const notifyError = (err: any) => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Une erreur est survenue: ${err}`,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const AlertDelete = async (_id: any) => {
    swalWithBootstrapButtons
      .fire({
        title: "Etes-vous sûr?",
        text: "Vous ne pouvez pas revenir en arrière?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprime-le !",
        cancelButtonText: "Non, annuler !",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteObservation(_id);
          swalWithBootstrapButtons.fire(
            "Supprimé !",
            "L'observation est supprimée.",
            "success"
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Annulé",
            "L'observation est en sécurité :)",
            "info"
          );
        }
      });
  };

  const [selectedPar, setSelectedPar] = useState<string>("");

  const handleSelectPar = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedPar(value);
  };

  const [modal_AddObservation, setmodal_AddObservation] =
    useState<boolean>(false);
  function tog_AddObservation() {
    setmodal_AddObservation(!modal_AddObservation);
  }

  const [modal_UpdateObservation, setmodal_UpdateObservation] =
    useState<boolean>(false);
  function tog_UpdateObservation() {
    setmodal_UpdateObservation(!modal_UpdateObservation);
  }

  const [updateAvisSmsSetting] = useUpdateSmsSettingByIdMutation();
  const [formData, setFormData] = useState({
    id: "",
    status: "",
  });

  useEffect(() => {
    if (AllSmsSettings !== undefined && isLoading === false) {
      const devoir_sms_setting = AllSmsSettings?.filter(
        (parametre) => parametre.service_name === "Observations"
      );
      setFormData((prevState) => ({
        ...prevState,
        id: devoir_sms_setting[0]?._id!,
        status: devoir_sms_setting[0]?.sms_status!,
      }));
    }
  }, [AllSmsSettings, isLoading]);

  const onChangeDocumentSmsSetting = () => {
    let updateData = {
      id: formData.id,
      status: formData.status === "1" ? "0" : "1",
    };
    updateAvisSmsSetting(updateData)
      .then(() =>
        setFormData((prevState) => ({
          ...prevState,
          status: formData.status === "1" ? "0" : "1",
        }))
      )
      .then(() =>
        notifySuccess("Paramètre Observations SMS a été modifié avec succès")
      );
  };

  const [createObservation] = useAddObservationMutation();

  const initialObservation = {
    titre: "",
    date: "",
    description: "",
    classe: [""],
    fichier_base64_string: "",
    fichier_extension: "",
    fichier: "",
    par: "",
  };

  const [observation, setObservation] = useState(initialObservation);

  const {
    titre,
    date,
    description,
    classe,
    fichier_base64_string,
    fichier_extension,
    fichier,
    par,
  } = observation;

  const onChangeObservation = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setObservation((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const handleFileUploadFile = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = (
      document.getElementById("fichier_base64_string") as HTMLFormElement
    ).files[0];
    if (file) {
      const { base64Data, extension } = await convertToBase64(file);
      const file_observation = base64Data + "." + extension;
      setObservation({
        ...observation,
        fichier: file_observation,
        fichier_base64_string: base64Data,
        fichier_extension: extension,
      });
    }
  };

  const onSubmitObservation = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      observation["date"] = formatDate(selectedDate);
      observation["classe"] = selectedColumnValues;
      observation["par"] = selectedPar;
      createObservation(observation)
        .then(() => notifySuccess("L'observation a été créée avec succès"))
        .then(() => setObservation(initialObservation));
    } catch (error) {
      notifyError(error);
    }
  };

  // Search & filter
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  // Stats
  const stats = useMemo(() => {
    return { total: data.length };
  }, [data]);

  const getFilteredObservations = () => {
    let filteredObservations = [...data];

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filteredObservations = filteredObservations.filter(
        (observation: any) =>
          observation?.titre?.toLowerCase().includes(term) ||
          observation?.par?.toLowerCase().includes(term) ||
          observation?.date?.toLowerCase().includes(term) ||
          observation?.description?.toLowerCase().includes(term) ||
          observation?.classe?.some((c: any) => c?.nom_classe?.toLowerCase().includes(term))
      );
    }

    return filteredObservations.reverse();
  };

  const columns = [
    {
      name: <span className="fw-semibold fs-13">Titre</span>,
      selector: (row: any) => row.titre,
      cell: (row: any) => (
        <div className="d-flex align-items-center gap-2">
          <div className="avatar-xs flex-shrink-0">
            <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-16">
              <i className="ri-file-text-line" />
            </div>
          </div>
          <span className="fw-medium fs-13">{row.titre}</span>
        </div>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: <span className="fw-semibold fs-13">Date de création</span>,
      selector: (row: any) => row.date,
      cell: (row: any) => (
        <span className="text-muted fs-13">
          <i className="ri-calendar-line me-1 text-primary" />
          {row.date}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Classe(s)</span>,
      selector: (row: any) => row?.classe?.[0]?.nom_classe || "",
      cell: (row: any) => (
        <div>
          {row.classe?.map((classe: any) => (
            <Badge
              key={classe._id}
              bg={"info-subtle" as any}
              text={"info" as any}
              className="fs-12 px-2 py-1 me-1 mb-1"
            >
              <i className="ri-group-line me-1" />
              {classe.nom_classe}
            </Badge>
          ))}
        </div>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: <span className="fw-semibold fs-13">Éditeur</span>,
      selector: (row: any) => row.par,
      cell: (row: any) => (
        <span className="fs-13">
          <i className="ri-user-settings-line me-1 text-muted" />
          {row.par}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Actions</span>,
      cell: (row: any) => (
        <div className="d-flex gap-1">
          <Link
            to="#"
            state={row}
            className="btn btn-soft-info btn-sm btn-icon"
            onClick={() => setShowObservation(true)}
            title="Voir détails"
          >
            <i className="ri-eye-line" />
          </Link>
          <Link
            to="#"
            state={row}
            className="btn btn-soft-success btn-sm btn-icon"
            onClick={() => tog_UpdateObservation()}
            title="Modifier"
          >
            <i className="ri-edit-2-line" />
          </Link>
          <button
            className="btn btn-soft-danger btn-sm btn-icon"
            onClick={() => AlertDelete(row._id)}
            title="Supprimer"
          >
            <i className="ri-delete-bin-2-line" />
          </button>
        </div>
      ),
    },
  ];

  const observationLocation = useLocation();

  const openFileInNewTab = (fileUrl: string, fileName: string) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.target = "_blank";
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleButtonClick = () => {
    const fileUrl = `${process.env.REACT_APP_BASE_URL}/observationFiles/${observationLocation.state.fichier}`;
    const fileName = "sample.pdf";

    openFileInNewTab(fileUrl, fileName);
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f3f6f9",
        fontWeight: "600",
        fontSize: "13px",
        color: "#495057",
        borderBottom: "2px solid #e9ebec",
      },
    },
    rows: {
      style: {
        fontSize: "13px",
        "&:hover": {
          backgroundColor: "#f3f6f9",
        },
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #e9ebec",
      },
    },
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Observations" pageTitle="Tableau de bord" />

          {/* KPI Cards */}
          <Row className="mb-3">
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-3">
                        <i className="ri-eye-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Total Observations</p>
                      <h4 className="mb-0">{stats.total}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-info-subtle text-info rounded-circle fs-3">
                        <i className="ri-chat-settings-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">SMS</p>
                      <div className="form-check form-switch mb-0">
                        <input
                          key={formData?.id!}
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id={formData.id}
                          checked={formData.status === "1"}
                          onChange={() => onChangeDocumentSmsSetting()}
                        />
                        {formData.status === "0" ? (
                          <span className="badge bg-warning-subtle text-warning">Désactivé</span>
                        ) : (
                          <span className="badge bg-success-subtle text-success">Activé</span>
                        )}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Data Table */}
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <Card.Header className="border-bottom-dashed bg-white">
                <Row className="g-3 align-items-center">
                  <Col lg={4} md={6}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Rechercher par titre, éditeur, date..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <Col lg={8} md={6} className="d-flex justify-content-end gap-2">
                    {searchTerm && (
                      <Button
                        variant="soft-secondary"
                        size="sm"
                        onClick={() => setSearchTerm("")}
                      >
                        <i className="ri-filter-off-line me-1" />
                        Réinitialiser
                      </Button>
                    )}
                    <Button
                      variant="primary"
                      onClick={() => tog_AddObservation()}
                      className="d-flex align-items-center gap-1"
                    >
                      <i className="ri-add-line fs-16" />
                      Nouvelle observation
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              {selectedRows.length > 0 && (
                <div className="bg-primary-subtle border-bottom p-3 d-flex align-items-center gap-3">
                  <span className="fw-semibold text-primary">
                    {selectedRows.length} sélectionné(s)
                  </span>
                  <Button variant="danger" size="sm" onClick={handleBulkDelete} className="d-flex align-items-center gap-1">
                    <i className="ri-delete-bin-2-line" />
                    Supprimer
                  </Button>
                  <Button variant="soft-secondary" size="sm" onClick={() => { setToggleCleared(!toggleCleared); setSelectedRows([]); }}>
                    <i className="ri-close-line me-1" />
                    Annuler
                  </Button>
                </div>
              )}
              <Card.Body className="p-0">
                <DataTable
                  columns={columns}
                  data={getFilteredObservations()}
                  selectableRows
                  selectableRowsVisibleOnly
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  pagination
                  paginationPerPage={15}
                  paginationRowsPerPageOptions={[10, 15, 25, 50]}
                  customStyles={customStyles}
                  noDataComponent={
                    <div className="text-center py-5">
                      <i className="ri-eye-line fs-1 text-muted d-block mb-2" />
                      <p className="text-muted mb-0">Aucune observation trouvée</p>
                    </div>
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                  }}
                  highlightOnHover
                  responsive
                />
              </Card.Body>
            </Card>
          </Col>

          {/* Add Modal */}
          <Modal
            className="fade"
            show={modal_AddObservation}
            onHide={() => tog_AddObservation()}
            centered
            size="lg"
          >
            <Modal.Header closeButton className="bg-primary-subtle">
              <h5 className="modal-title d-flex align-items-center gap-2">
                <i className="ri-add-circle-line fs-20" />
                Nouvelle observation
              </h5>
            </Modal.Header>
            <Modal.Body className="px-4 py-3">
              <Form className="create-form" onSubmit={onSubmitObservation}>
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-information-line me-1" />
                  Informations générales
                </p>
                <Row className="g-3 mb-4">
                  <Col md={6}>
                    <Form.Label htmlFor="titre" className="fw-medium">
                      <i className="ri-file-text-line me-1 text-primary" />
                      Titre <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="titre"
                      name="titre"
                      onChange={onChangeObservation}
                      value={observation.titre}
                      placeholder="Titre de l'observation"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label htmlFor="date" className="fw-medium">
                      <i className="ri-calendar-line me-1 text-info" />
                      Date <span className="text-danger">*</span>
                    </Form.Label>
                    <Flatpickr
                      className="form-control"
                      placeholder="Sélectionner la date"
                      onChange={handleDateChange}
                      options={{
                        dateFormat: "d M, Y",
                        locale: French,
                      }}
                      id="date"
                      name="date"
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label htmlFor="classe" className="fw-medium">
                      <i className="ri-group-line me-1 text-success" />
                      Classe(s) <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      isMulti
                      options={optionColumnsTable}
                      onChange={handleSelectValueColumnChange}
                      placeholder="Sélectionner les classes..."
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label htmlFor="par" className="fw-medium">
                      <i className="ri-user-settings-line me-1 text-warning" />
                      Éditeur <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={[
                        { value: "Administration", label: "Administration" },
                        ...[...AllEnseignants].sort((a: any, b: any) => (`${a.nom_enseignant} ${a.prenom_enseignant}`).localeCompare(`${b.nom_enseignant} ${b.prenom_enseignant}`, "fr")).map((enseignant: any) => ({
                          value: `${enseignant.nom_enseignant} ${enseignant.prenom_enseignant}`,
                          label: `${enseignant.nom_enseignant} ${enseignant.prenom_enseignant}`,
                        })),
                      ]}
                      onChange={(opt: any) => { const e = { target: { value: opt?.value || "" } } as any; handleSelectPar(e); }}
                      placeholder="Rechercher un éditeur..."
                      isClearable
                      isSearchable
                      noOptionsMessage={() => "Aucun éditeur trouvé"}
                    />
                  </Col>
                </Row>

                <hr className="text-muted" />
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-attachment-2 me-1" />
                  Détails & pièce jointe
                </p>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Label htmlFor="description" className="fw-medium">
                      <i className="ri-align-left me-1 text-muted" />
                      Description
                    </Form.Label>
                    <textarea
                      className="form-control"
                      id="description"
                      name="description"
                      value={observation.description}
                      onChange={onChangeObservation}
                      rows={3}
                      placeholder="Détails de l'observation..."
                    />
                  </Col>
                  <Col md={12}>
                    <Form.Label htmlFor="fichier_base64_string" className="fw-medium">
                      <i className="ri-upload-cloud-2-line me-1 text-warning" />
                      Fichier joint
                    </Form.Label>
                    <div className="input-group">
                      <span className="input-group-text bg-light">
                        <i className="ri-file-pdf-line text-danger" />
                      </span>
                      <input
                        className="form-control"
                        type="file"
                        id="fichier_base64_string"
                        name="fichier_base64_string"
                        onChange={(e) => handleFileUploadFile(e)}
                      />
                    </div>
                    <small className="text-muted">PDF, Image ou document (optionnel)</small>
                  </Col>
                </Row>
                <div className="hstack gap-2 justify-content-end border-top mt-4 pt-3">
                  <Button
                    variant="light"
                    onClick={() => {
                      tog_AddObservation();
                      setObservation(initialObservation);
                    }}
                  >
                    <i className="ri-close-line me-1" />
                    Annuler
                  </Button>
                  <Button
                    onClick={() => tog_AddObservation()}
                    type="submit"
                    variant="primary"
                  >
                    <i className="ri-check-line me-1" />
                    Enregistrer
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Update Modal */}
          <Modal
            className="fade"
            show={modal_UpdateObservation}
            onHide={() => tog_UpdateObservation()}
            centered
            size="lg"
          >
            <Modal.Header closeButton className="bg-success-subtle">
              <h5 className="modal-title">
                <i className="ri-edit-2-line me-2" />
                Modifier observation
              </h5>
            </Modal.Header>
            <Modal.Body>
              <UpdateObservation
                modal_UpdateObservation={modal_UpdateObservation}
                setmodal_UpdateObservation={setmodal_UpdateObservation}
              />
            </Modal.Body>
          </Modal>
        </Container>

        {/* Detail Offcanvas */}
        <Offcanvas
          show={showObservation}
          onHide={() => setShowObservation(false)}
          placement="end"
          style={{ width: "420px" }}
        >
          <Offcanvas.Header closeButton className="border-bottom bg-light">
            <Offcanvas.Title className="d-flex align-items-center gap-2">
              <i className="ri-eye-line text-primary fs-20" />
              Détails de l'observation
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="mb-4">
              <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                Titre
              </label>
              <p className="fw-medium mb-0 fs-14">{observationLocation?.state?.titre || "—"}</p>
            </div>

            <div className="mb-4">
              <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                Description
              </label>
              <p className="mb-0">{observationLocation?.state?.description || "—"}</p>
            </div>

            <Row className="mb-4 g-3">
              <Col xs={6}>
                <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                  Date
                </label>
                <span>
                  <i className="ri-calendar-line me-1 text-primary" />
                  {observationLocation?.state?.date}
                </span>
              </Col>
              <Col xs={6}>
                <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                  Éditeur
                </label>
                <span>
                  <i className="ri-user-settings-line me-1 text-muted" />
                  {observationLocation?.state?.par}
                </span>
              </Col>
            </Row>

            <div className="mb-4">
              <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                Classe(s)
              </label>
              {observationLocation?.state?.classe?.map((c: any) => (
                <div key={c._id} className="d-flex align-items-center gap-2 mb-2">
                  <div className="avatar-xs">
                    <div className="avatar-title bg-info-subtle text-info rounded-circle">
                      <i className="ri-group-line" />
                    </div>
                  </div>
                  <span className="fw-medium">{c.nom_classe}</span>
                </div>
              ))}
            </div>

            {observationLocation?.state?.fichier && observationLocation.state.fichier !== "" && (
              <div>
                <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                  Fichier joint
                </label>
                <Button variant="soft-danger" size="sm" onClick={handleButtonClick} className="d-flex align-items-center gap-1">
                  <i className="ri-file-pdf-line fs-16" />
                  Ouvrir le fichier
                </Button>
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </React.Fragment>
  );
};
export default Observations;
